import { Provider as UsersProvider } from './users/context';
import { Provider as PermissionsProvider } from './permissions/context';
import { Provider as RolesProvider } from './roles/context';
import { Provider as LanguagesProvider } from './languages/context';
import { Provider as ProductsTypesProvider } from './productsTypes/context';
import { Provider as CompanyTypesProvider } from './companyTypes/context';
import { Provider as CurrenciesProvider } from './currencies/context';
import { Provider as authProvider } from './auth/context';
import { Provider as ClientsProvider } from './clients/context';
import { Provider as SettingsProvider } from './settings/context';
import { Provider as ExchangeRatesProvider } from './exchangeRates/context';
import { Provider as BankAccountsProvider } from './bankAccounts/context';
import { Provider as CompaniesProvider } from './companies/context';
import { Provider as CountriesProvider } from './countries/context';
import { Provider as TimeZonesProvider } from './timeZones/context';
import { Provider as TravelFileAttributesProvider } from './travelFileAttributes/context';
import { TravelFileNotesProvider } from './travelFileNotes/context';
import { Provider as ComponentLevelsProvider } from './componentLevels/context';
import { Provider as ComponentTypesProvider } from './componentTypes/context';
import { Provider as IncomeTypesProvider } from './incomeTypes/context';
import { Provider as EmailSettingsProvider } from './emailSettings/context';
import { Provider as EventsProvider } from './events/context';
import { Provider as ToursProvider } from './tours/context';
import { Provider as FlightsProvider } from './flights/context';
import { Provider as AirlinesProvider } from './airlines/context';
import { Provider as VouchersProvider } from './vouchers/context';
import { Provider as DocumentCountersProvider } from './documentCounters/context';
import { Provider as ServicePricesProvider } from './servicePrices/context';
import { Provider as PassengersProvider } from './passengers/context';
import { Provider as ClassesProvider } from './classes/context';
import { Provider as TravelFilesProvider } from './travelFiles/context';
import { Provider as MarketsProvider } from './markets/context';
import { Provider as MealsProvider } from './meals/context';
import { Provider as DestinationsProvider } from './destinations/context';
import { Provider as CitiesProvider } from './cities/context';
import { Provider as LocationsProvider } from './locations/context';
import { Provider as TravelAgentTypesProvider } from './travelAgentTypes/context';
import { Provider as PriceComponentsProvider } from './priceComponents/context';
import { Provider as CategoriesProvider } from './categories/context';
import { Provider as EmailEngagementsProvider } from './emailEngagements/context';
import { Provider as EmailTemplatesProvider } from './emailTemplates/context';
import { Provider as ServiceAbbreviationsProvider } from './serviceAbbreviations/context';
import { Provider as PriceLevelsProvider } from './priceLevels/context';
import { Provider as GeneralAccountsProvider } from './generalAccounts/context';
import { Provider as CreditCardsProvider } from './creditCards/context';
import { Provider as CRMTypesProvider } from './crmTypes/context';
import { Provider as CRMActionsProvider } from './crmActions/context';
import { Provider as ServiceTypesProvider } from './serviceTypes/context';
import { Provider as DiscountAccountsProvider } from './discountAccounts/context';
import { Provider as IncomeAccountsProvider } from './incomeAccounts/context';
import { Provider as CreditPaymentOptionsProvider } from './creditPaymentOptions/context';
import { Provider as PaymentsTerminalsProvider } from './paymentsTerminals/context';
import { Provider as PassengerAttributesProvider } from './passengerAttributes/context';
import { Provider as FacilitiesProvider } from './facilities/context';
import { Provider as HotelsProvider } from './hotels/context';
import { Provider as CountryCodesProvider } from './countryCodes/context';
import { Provider as QueuesProvider } from './queues/context';
import { Provider as SupplierAccountsProvider } from './supplierAccounts/context';
import { Provider as SupplierServicesProvider } from './supplierServices/context';
import { Provider as CommissionTypesProvider } from './commissionTypes/context';
import { Provider as PaymentMethodsProvider } from './paymentMethods/context';
import { Provider as ServiceStartDateOptionsProvider } from './serviceStartDateOptions/context';
import { Provider as ServiceAddressToOptionsProvider } from './serviceAddressToOptions/context';
import { Provider as ServicePaidByOptionsProvider } from './servicePaidByOptions/context';
import { Provider as ServiceAttributesProvider } from './serviceAttributes/context';
import { Provider as SupplierApplyBankTransferChargeOptionsProvider } from './supplierApplyBankTransferChargeOptions/context';
import { Provider as CreditCompaniesProvider } from './creditCompanies/context';
import { Provider as CreditCompanyTypesProvider } from './creditCompanyTypes/context';
import { Provider as TravelAgencyAccountsProvider } from './travelAgencyAccounts/context';
import { Provider as PaymentTermsOptionsProvider } from './paymentTermsOptions/context';
import { Provider as SupplierInterfaceProvider } from './supplierInterface/context';
import { Provider as PassportsProvider } from './passports/context';
import { Provider as FrequentFlyersProvider } from './frequentFlyers/context';
import { Provider as VisasProvider } from './visas/context';
import { Provider as PaymentGatewayProvider } from './paymentGateway/context';
import { Provider as AgentCommissionAccountsProvider } from './agentCommissionAccounts/context';
import { Provider as BspDataProvider } from './bspData/context';
import { Provider as AmadeusGatewayProvider } from './amadeusGateways/context';
import { Provider as RegionsProvider } from './regions/context';
import { Provider as AirportsProvider } from './airports/context';
import { Provider as PnrDetailsProvider } from './pnrDetails/context';
import { Provider as PassengerPhonesProvider } from './passengerPhones/context';
import { Provider as PassengerEmailsProvider } from './passengerEmail/context';
import { DataSyncProvider } from './dataSync/context';
import { DbManagerProvider } from './dbManager/context';
import { Provider as AppSettingsProvider } from './appSettings/context';
import { Provider as UserPreferencesProvider } from './userPreferences/context';
import { SocketProvider } from './socket/SocketProvider';

export default [
    authProvider,
    SocketProvider,
    UsersProvider,
    PermissionsProvider,
    RolesProvider,
    CompanyTypesProvider,
    LanguagesProvider,
    ProductsTypesProvider,
    CurrenciesProvider,
    ClientsProvider,
    SettingsProvider,
    ExchangeRatesProvider,
    CompaniesProvider,
    CountriesProvider,
    TimeZonesProvider,
    TravelFileAttributesProvider,
    TravelFileNotesProvider,
    ComponentLevelsProvider,
    ComponentTypesProvider,
    IncomeTypesProvider,
    EmailSettingsProvider,
    EventsProvider,
    ToursProvider,
    FlightsProvider,
    AirlinesProvider,
    VouchersProvider,
    DocumentCountersProvider,
    ServicePricesProvider,
    PassengersProvider,
    ClassesProvider,
    TravelFilesProvider,
    MarketsProvider,
    MealsProvider,
    DestinationsProvider,
    CitiesProvider,
    LocationsProvider,
    TravelAgentTypesProvider,
    PriceComponentsProvider,
    CategoriesProvider,
    EmailEngagementsProvider,
    EmailTemplatesProvider,
    ServiceAbbreviationsProvider,
    PriceLevelsProvider,
    GeneralAccountsProvider,
    CreditCardsProvider,
    CRMTypesProvider,
    CRMActionsProvider,
    ServiceTypesProvider,
    DiscountAccountsProvider,
    IncomeAccountsProvider,
    CreditPaymentOptionsProvider,
    PaymentsTerminalsProvider,
    BankAccountsProvider,
    PassengerAttributesProvider,
    FacilitiesProvider,
    HotelsProvider,
    CountryCodesProvider,
    QueuesProvider,
    SupplierAccountsProvider,
    CommissionTypesProvider,
    PaymentMethodsProvider,
    ServiceStartDateOptionsProvider,
    ServiceAddressToOptionsProvider,
    ServicePaidByOptionsProvider,
    ServiceAttributesProvider,
    SupplierApplyBankTransferChargeOptionsProvider,
    SupplierAccountsProvider,
    CreditCompaniesProvider,
    CreditCompanyTypesProvider,
    TravelAgencyAccountsProvider,
    PaymentTermsOptionsProvider,
    SupplierInterfaceProvider,
    PassportsProvider,
    FrequentFlyersProvider,
    VisasProvider,
    PaymentGatewayProvider,
    AgentCommissionAccountsProvider,
    BspDataProvider,
    AmadeusGatewayProvider,
    SupplierServicesProvider,
    RegionsProvider,
    AirportsProvider,
    PnrDetailsProvider,
    PassengerPhonesProvider,
    PassengerEmailsProvider,
    DataSyncProvider,
    DbManagerProvider,
    AppSettingsProvider,
    UserPreferencesProvider
];
